import "./src/styles/global.css";
import { initializeG2DigitalMarkets } from "./src/utils/g2-digital-markets";
import {
  initializeGoogleTag,
  trackGooglePageView,
} from "./src/utils/google-tag";
import {
  initializeSignupAttribution,
  syncSignupAttribution,
  startSignupLinkSync,
} from "./src/utils/signup-attribution";

export {
  wrapRootElement,
  wrapPageElement,
} from "./src/components/website-status/wrappers";

export const onClientEntry = () => {
  initializeSignupAttribution();
  initializeG2DigitalMarkets();
};

export const onInitialClientRender = () => {
  initializeGoogleTag();
  startSignupLinkSync();
  trackGooglePageView(window.location);
};

export const onRouteUpdate = ({ location }) => {
  syncSignupAttribution(location);
  trackGooglePageView(location);
};
